module.exports = __webpack_public_path__ + "img/UCL360_banner2.78bd3840.png";